/**
 * Boomfection Landing — Quests & Challenges Module
 * Daily quests and weekly challenges
 * @copyright reDim GmbH | @link https://www.redim.de | @contact team@redim.de
 */

import { escapeHtml } from '/js/ui/utils.js';
import { safeJsonFetch } from './LandingUtils.js';
import { t } from '/js/i18n.js';

/**
 * Loads daily quest list into the landing page.
 * All user-facing strings are sanitized via escapeHtml; numeric values are integers from API.
 */
export async function loadDailyQuests() {
    const container = document.getElementById('landing-quest-list');
    if (!container) return;

    try {
        const data = await safeJsonFetch('/api/quests/daily');
        if (!data) return;

        if (data.quests && data.quests.length > 0) {
            container.innerHTML = data.quests
                .map(
                    (q) =>
                        `<div class="quest-item">` +
                        `<div class="quest-header">` +
                        `<span class="quest-desc">${escapeHtml(q.description)}</span>` +
                        `<span class="quest-points">+${parseInt(q.points) || 0}P</span>` +
                        `</div>` +
                        `<div class="quest-progress-text">${t('quests.target')}: ${parseInt(q.target) || 0}</div>` +
                        `</div>`
                )
                .join('');
        } else {
            container.innerHTML = `<div class="leaderboard-empty">${t('quests.noQuests')}</div>`;
        }
    } catch (err) {
        console.error('[Landing] Failed to load daily quests:', err);
        container.innerHTML = `<div class="leaderboard-empty">${t('quests.loadError')}</div>`;
    }
}

/**
 * Loads weekly challenge list into the landing page.
 * All user-facing strings are sanitized via escapeHtml; numeric values are integers from API.
 */
export async function loadWeeklyChallenges() {
    const container = document.getElementById('landing-challenge-list');
    if (!container) return;

    try {
        const data = await safeJsonFetch('/api/challenges/weekly');
        if (!data || !data.challenges || data.challenges.length === 0) {
            container.innerHTML = `<div class="leaderboard-empty">${t('quests.noChallenges')}</div>`;
            return;
        }

        container.innerHTML = data.challenges
            .map(function (c) {
                return (
                    `<div class="quest-row">` +
                    `<div class="quest-info">` +
                    `<span class="quest-desc">${escapeHtml(c.description)}</span>` +
                    `<span class="quest-progress-text">${t('quests.reward')}: ${parseInt(c.reward) || 0} ${t('quests.points')}</span>` +
                    `</div>` +
                    `<div class="quest-target">${parseInt(c.target) || 0}x</div>` +
                    `</div>`
                );
            })
            .join('');
    } catch (err) {
        console.error('[Landing] Failed to load weekly challenges:', err);
    }
}
